"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const DragHandle_1 = tslib_1.__importDefault(require("@mui/icons-material/DragHandle"));
const Search_1 = tslib_1.__importDefault(require("@mui/icons-material/Search"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Checkbox_1 = tslib_1.__importDefault(require("@mui/material/Checkbox"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const List_1 = tslib_1.__importDefault(require("@mui/material/List"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const ListItemButton_1 = tslib_1.__importDefault(require("@mui/material/ListItemButton"));
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const styles_1 = require("@mui/material/styles");
const mui5_1 = require("@mnemonic/mui5");
const useDragAndDrop_1 = require("./useDragAndDrop");
const utils_1 = require("./utils");
const ColumnList = (props) => {
    const { EmptyStateProps: defaultEmptyErrorState } = (0, styles_1.useThemeProps)({ props, name: "ColumnSelectorList" });
    const { items, searchTerm, onChange, EmptyStateProps, ...rest } = props;
    const drag = (0, useDragAndDrop_1.useDragAndDrop)();
    const filteredItems = (0, utils_1.filterColumnSelectorItems)(items, searchTerm).map(({ columnId }) => columnId);
    return filteredItems.length > 0 ? (react_1.default.createElement(List_1.default, { sx: { minWidth: "300px" }, ...rest }, items?.map((value, index) => {
        const { columnId, label, checked, ...ListItemProps } = value;
        const isDraggingOver = index === drag.dragOverIndex;
        const isDragging = index === drag.dragIndex;
        // hide item when search has been made and the item received 0 hits.
        if (searchTerm && !filteredItems.includes(columnId))
            return null;
        return (react_1.default.createElement(ListItem_1.default, { key: columnId, secondaryAction: react_1.default.createElement(IconButton_1.default, { edge: "end", sx: {
                    cursor: () => {
                        if (isDragging)
                            return "grabbing";
                        return checked ? "grab" : "unset";
                    },
                }, disabled: !checked },
                react_1.default.createElement(DragHandle_1.default, null)), onDragStart: (e) => drag.onDragStart(e, index), onDragEnter: (e) => drag.onDragEnter(e, index), onDragOver: (e) => drag.onDragOver(e), onDragEnd: (e) => drag.onDragEnd(e), onDrop: (e) => {
                const updatedItems = drag.onDrop(e, index, items);
                if (updatedItems)
                    onChange(e, updatedItems);
            }, sx: isDraggingOver && checked ? { boxShadow: (theme) => theme.shadows[1] } : {}, disablePadding: true, draggable: checked, ...ListItemProps },
            react_1.default.createElement(ListItemButton_1.default, { dense: true, disableRipple: true, disabled: isDragging },
                react_1.default.createElement(ListItemIcon_1.default, null,
                    react_1.default.createElement(Checkbox_1.default, { edge: "start", checked: checked, onChange: (e) => {
                            const updatedItems = (0, utils_1.toggleChecked)(items, index);
                            onChange(e, updatedItems);
                        }, tabIndex: -1, disableRipple: true })),
                react_1.default.createElement(ListItemText_1.default, { primary: label }))));
    }))) : (react_1.default.createElement(Box_1.default, { sx: { pt: 2, minWidth: "400px" } },
        react_1.default.createElement(mui5_1.EmptyState, { Icon: Search_1.default, description: defaultEmptyErrorState?.description, title: defaultEmptyErrorState?.title, ...EmptyStateProps })));
};
exports.default = ColumnList;
